import { post, get, patch, deleteRequest } from "./restApi";

export const createInstallationOrder = (payload) => {
    return post("installation-orders/create", { ...payload });
};

export const getInstallationOrders = (payload) => {
    return post("installation-orders/get-list", payload);
}
export const getInstallationOrderById = (id) => {
    return get(`installation-orders/get-by-id/${id}`);
}
export const deleteInstallationOrder = (id, payload) => {
    return deleteRequest(`installation-orders/delete/` + id, payload);
}
export const updateInstallationOrder = (id, payload) => {
    return patch(`installation-orders/update/${id}`, payload);
}
export const getInstallationOrderAssignUsersByInstallationOrderId = (id) => {
    return get(`installation-orders/get-assign-users/${id}`);
}
export const replacementAssignUser = (payload) => {
    return post(`installation-orders/replace-assign-users`, payload);
}
export const confirmCloseInstallationOrder = (payload) => {
    return post(`installation-orders/confirm-close`, payload);
}
export const confirmReopenInstallationOrder = (payload) => {
    return post(`installation-orders/confirm-reopen`, payload);
}
export const createInstallationOrderAssignUser = (payload) => {
    return post(`installation-orders/create-assign-user`, payload);
}
export const getSumJobCostsByInstallationOrderId = (installationOrderId) => {
    return get(`installation-orders/installation-order-assign-user-sum-job-costs/${installationOrderId}`);
}